import { FunctionComponent, useEffect } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'store';
import { useDispatch } from 'react-redux';
import { impersonateThunk } from 'actions/login/LoginActions';
import { cleanAll } from 'actions/ActionUtils';
import { useQueryParams } from 'hooks';

// Sent by the Organization Portal so its sessions show the "logged in as" banner; admin impersonations don't send it.
const ORGANIZATION_SOURCE = 'organization';

interface Props {
    marketplaceId: number;
    token: string;
}
export const Impersonate: FunctionComponent<Props> = props => {
    const dispatch = useDispatch();
    const queryParams = useQueryParams();

    useEffect(() => {
        const fromOrganization = queryParams.get('source') === ORGANIZATION_SOURCE;

        cleanAll(dispatch, true);
        dispatch(impersonateThunk(props.marketplaceId, props.token, fromOrganization));
    }, []);

    document.title = 'Impersonation - Cuddles';

    return null;
};

const mapStateToProps = (state: RootState, ownProps: any) => {
    return {
        ...ownProps,
        marketplaceId: ownProps.match.params.marketplaceId ? parseInt(ownProps.match.params.marketplaceId) : undefined,
        token: ownProps.match.params.token
    };
};

export default connect(mapStateToProps)(Impersonate);
